import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addTrendBoard } from '@services/trendResearch';

const MoodBoardCreateForm = ({
	setDebouncedSearch,
	setIsGetMoodboard,
	setPage,
	onSearch,
	debouncedSearch,
	setThreeApi
}) => {
	const dispatch = useDispatch();
	const [name, setMoodboardName] = useState('');

	const moodboards = useSelector((store) => store.trendResearchStore.allMoodboards);

	const changeMoodboard = (e) => {
		setPage(0);
		setIsGetMoodboard(false);
		setMoodboardName(e.target.value);
		setDebouncedSearch(e.target.value);
	};

	const saveMoodBoard = async () => {
		try {
			dispatch(openLoader());
			let postData = { name };

			await addTrendBoard(postData);
			setThreeApi(true);
			setMoodboardName('');
			onSearch('');

			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};
	const addMoodboard = async () => {
		if (name) {
			await saveMoodBoard();
		}
	};
	const handleFocus = () => {
		onSearch(''); // Fetch initial data when input is focused
	};

	useEffect(() => {
		if (!debouncedSearch || debouncedSearch === '') {
			setMoodboardName('');
		}
	}, [debouncedSearch]);
	return (
		<>
			<div className="input-tag">
				<input
					onChange={changeMoodboard}
					onFocus={handleFocus}
					type="text"
					autoComplete="off"
					placeholder="Search and select or create new"
					value={name}
				/>
				<img
					className="cursor-pointer"
					src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`}
					onClick={() => {
						setIsGetMoodboard(true);
						setMoodboardName('');
						onSearch('');
					}}
				/>
			</div>
			{name && moodboards.length === 0 && (
				<div className="new-create py-2 px-3 mt-12 cursor-pointer" onClick={addMoodboard}>
					<p className="regular-14 gray_dark_01 weight-600">
						Create new: <span className="weight-400">{name}</span>
					</p>
				</div>
			)}
		</>
	);
};

export default MoodBoardCreateForm;
